import React from 'react';
import { HStack, useThemeName } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
function ThemedImage({ resourceKey, testID, alt, style }) {
    const theme = useThemeName();
    const mainKey = resourceKey.endsWith('Light')
        ? resourceKey.slice(0, resourceKey.length - 5)
        : resourceKey.slice(0, resourceKey.length - 4);
    const rKey = `${mainKey}${theme === 'light' ? 'Light' : 'Dark'}`;
    const resource = i18n.t(rKey);
    return (React.createElement(HStack, { testID: testID },
        React.createElement("img", { src: resource, alt: alt, id: testID ?? rKey, style: style })));
}
export { ThemedImage };
